/*
 * @FilePath: index.js
 * @Author: chenwei
 * @Date: 2022-05-19 10:39:25
 * @LastEditors: chenwei
 * @LastEditTime: 2022-09-19 09:11:58
 * Copyright: 2022 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion: 
 */
import {post} from '@/utils/request'
import {proxyHeader} from "@/utils/config"

//遥感云计算申请次数
export const getJupyterLog = p => post(proxyHeader+'service/dataprocess-service/jupyterLog/applyCount', p);

//遥感云计算申请时长
export const getApplyTime = p => post(proxyHeader+'service/dataprocess-service/jupyterLog/applyTime', p);

//卫星申请次数
export const getSatelliteApplyCount= p => post(proxyHeader+'service/satellite-service/satellite-apply-for/applyCount', p);



//产品生产数量统计
export const getSumAlgoProductCount= p => post(proxyHeader+'service/product-service/product-data-file/sumAlgoProductCount', p);

//产品生产数据量统计
export const getSumAlgoFileUsage= p => post(proxyHeader+'service/product-service/product-data-file/sumAlgoFileUsage', p);

//产品汇交数量统计
export const getSumUploadProductCount= p => post(proxyHeader+'service/product-service/product-data-file/sumUploadProductCount', p);

//算法汇交数量统计
export const getAlgoUploadCount= p => post(proxyHeader+'service/dataprocess-service/algorithm/uploadCount', p);




//系统访问次数
export const getSysRecord= p => post(proxyHeader+'service/common-service/accress-record/sumCount', p);

//各省访问量统计
export const getSysAccessIp= p => post(proxyHeader+'service/common-service/sysAccessIp/sumCount', p);

//卫星数据下载量统计
export const getSumStFileUsage= p => post(proxyHeader+'service/order-service/order/sumStFileUsage', p);

//产品数据下载量统计
export const getSumProdFileUsage= p => post(proxyHeader+'service/order-service/order/sumProdFileUsage', p);
